<template>
  <div>
    <Header />
    <div
      class="spinner"
      style="position:relative !important; margin-top: 40px"
      v-if="loadingItems"
    ></div>
    <div v-else class="w-full mx-auto">
      <ul class="flex flex-col">
        <li class="border-gray-400 flex flex-row mb-2">
          <div
            :class="[
              'w-full select-none cursor-pointer rounded-md items-center p-3 transition duration-500 ease-in-out transform hover:-translate-y-1 hover:shadow-lg',
              theme.card&&theme.card.backgroundColor,
            ]"
          >
            <div
              v-for="(menuSubItems, index) in groupedMenuSubItems"
              :key="index"
              class="flex flex-1 flex-row flex-wrap text-center"
            >
              <div
                v-for="(menuSubItem, itemIndex) in menuSubItems"
                :key="menuSubItem.Id"
                class="w-full border-solid"
              >
                <p v-if="itemIndex != 0" class="text-gray-500 text-xs">
                  {{ lang.or[language] }}
                </p>
                <span :class="[theme.card.title]" 
                :style="makeStyles(hasKiosk&&titleFont,hsKiosk&&titleTextTransform)"
                v-trans:name="menuSubItem">{{
                  menuSubItem.name_nl
                }}</span>
                <span :class="[theme.card.title]" v-if="menuSubItem.price">
                  (+{{ currency
                  }}{{
                    (Math.round(menuSubItem.price * 100) / 100).toFixed(2)
                  }})</span
                ><br />
                <span
                  :class="[theme.card.title]"
                  v-trans:description="menuSubItem"
                  class="text-gray-600 text-sm"
                  ><br />{{ menuSubItem.description_nl }}</span
                >
              </div>
              <h2 v-if="Object.keys(groupedMenuSubItems).length > index">
                <span>//</span>
              </h2>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import lang from "../lang";
import Header from "../components/Header";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      lang: lang,
    };
  },
  components: { Header },
  computed: mapGetters([
    "loadingItems",
    "groupedMenuSubItems",
    "currency",
    "language",
    "hasKiosk",
    "theme",
  ]),
  ...mapGetters("Theme", [
    "titleTextTransform",
    "titleFont"
  ]),
  mounted() {
    this.$store.commit("updateCategoryId", this.$route.params.categoryId);
    this.$store.dispatch("GET_MENU_SUBITEMS", this.$route.params.menuItemId);
  },
};
</script>
<style scoped>
.divided {
  background: linear-gradient(
    transparent 45%,
    black 45%,
    black 55%,
    transparent 55%
  );
}

.divided span {
  background: white;
  padding: 0 5px;
}

.divided span:last-of-type {
  float: right;
}
h2 {
  width: 100%;
  text-align: center;
  border-bottom: 1px solid #dcdcdc;
  line-height: 0.1em;
  margin: 20px 0 20px;
}

h2 span {
  background: #dcdcdc;
  padding: 0 5px;
}
</style>
